import { Outlet } from "react-router-dom";
import Navbar from "../components/navbar/Navbar";
import "./MainLayout.css";
import { useTheme } from "../context/ThemeContext";

function MainLayout(props) {
  const { theme } = useTheme();
  const navClass = theme === 'light'
    ? 'tw-bg-white tw-border-b tw-border-gray-200'
    : 'tw-bg-gradient-to-b tw-from-[#4b1a77] tw-to-[#1f0439]';

  return (
    <div className="mainLayout" style={{ backgroundColor: 'var(--kk-bg-alt)', transition: 'background-color 0.25s ease' }}>
      <Navbar className={navClass} title={props.title} />
      <Outlet />
    </div>
  );
}

export default MainLayout;
